export default {
    namespaced: true,
    state: {
        item: {
            odometer: {
                photos: []
            }
        },
    },
}